(function (ws) {
    'use strict';
    ws.views.savedCartView = ws.views.googleAnalytics.extend({

        /**
         * Google Analytics Variables
         */
        GTM_EVENT_CATEGORY: 'order_activity',
        GTM_EVENT_CONTINUE_ACTION: 'saved_cart_continue',

        events: {
            'click .csc-make-active-button': 'makeActiveCart',
            'click .continue': 'continue'
        },

        /**
         * Initialize function
         */
        initialize: function() {
            this.$makeActiveForm = this.$('.csc-make-active-form');
            this.$is3PLOrderPresent = this.$('.is3PLOrderPresent').val() === 'true';
            this.confirmModalId = this.$('.crt-clear-confirm').attr('id');
            this.proceed = this.$('.proceed');
            $('.yes').on('click', this.clearCart.bind(this));
        },

        /**
         *
         */
        clearCart: function () {
            this.eventAgg.trigger(this.confirmModalId + 'close');
            this.$is3PLOrderPresent = false;
            this.continue();
        },

        /**
         *
         */
        continue: function () {
            if (this.$is3PLOrderPresent) {
                this.eventAgg.trigger(this.confirmModalId);
            } else {
                this.proceed.val(true);
                this.eventAgg.trigger('openSavedCartContinueModalConfirmation');
            }
        },

        /**
         * Make current cart active
         */
        makeActiveCart: function() {
            this.gtmEventTracking(this.GTM_EVENT_CATEGORY, this.GTM_EVENT_CONTINUE_ACTION);
            this.$makeActiveForm.submit();
        }
    });
})(westcon);
